import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanies = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5 23H1V13H5",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 16H11",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 19H11",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 13H11",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 6V2L23 5V23H5V9H15V23",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 19V9",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		})
	]
});
export default SvgCompanies;
